import { useEffect, useState } from "react";
import EmployeeLayout from "../../../layouts/employee/EmployeeLayout";
import MDButton from "../../../components/MDButton";
import ConfirmationDialog from "../../../components/ConfirmationDialog";
import WithOktaAuth from "../../../components/WithOktaAuth";
import { NewButton, EditButton, DetailButton } from "../../../components/Buttons";
import { EDIT, NEW, DETAIL, UnpaidLeaveDialog } from "../../../views/Dialogs/EmployeeDialog/UnpaidLeaveDialog";
import { employeeAPI } from "../../../apis/employeeAPI";



const UnpaidLeave = () => {
  const { oktaAuth, authState } = WithOktaAuth();
  const [renderLock, setRenderLock] = useState(false); // avoid pagination error
  const [userInfo, setUserInfo] = useState(null);
  const [generalSettings, setGeneralSettings] = useState({});
  const [data, setData] = useState({});
  const [openConfirm, setConfirm] = useState(false);
  const [deleteID, setDeleteID] = useState(null);
  const [filterData, setFilter] = useState({
    date_filter: new Date().toLocaleDateString('en-CA'),
    status_filter: null,
    employee_id_filter: null,
  });
  const [page, setPage] = useState({
    page: 1,
    pageSize: 10
  });

  useEffect(() => {
    if (authState?.isAuthenticated) {
      oktaAuth.getUser().then((info) => {
        setUserInfo(info);
        renderRows();
      }).catch((err) => {
        console.error('error fetching user info:', err)
      })
      employeeAPI.getGeneralSettings().then((res) => {
        setGeneralSettings(res.data);
      })
    }
  }, [authState]);

  useEffect(() => {
    renderRows();
  }, [
    filterData,
    page,
    generalSettings,
    userInfo,
  ]);

  const handleChangeFilter = (filterData) => {
    setFilter(filterData);
    setPage({ ...page, page: 1 });
  }

  const handleChangePage = (page) => {
    setPage(page);
  }

  const handleDelete = () => {
    employeeAPI.deleteUnpaidLeave(
      {
        id: deleteID,
        hrEmail: userInfo.email,
      }
    ).then(() => {
      renderRows();
    })
  }

  const renderRows = () => {
    if (renderLock) {
      return;
    }
    setRenderLock(true);
    employeeAPI.listUnpaidLeave(
      {
        startDate: filterData.date_filter,
        endDate: filterData.date_filter,
        employeeNumber: filterData.employee_id_filter,
        ...page
      }
    ).then((res) => {
      if (!generalSettings || !userInfo) {
        return;
      }

      res.data.data = res.data.data.map((item) => {
        return {
          ...item,
          employeeNumber: (
            <UnpaidLeaveDialog
              button={DetailButton(item.employeeNumber)}
              item={item}
              title={DETAIL}
              renderRows={renderRows}
              userInfo={userInfo}
              generalSettings={generalSettings}
            />
          ),
          action: (
            <div style={{ display: 'flex' }}>
              <UnpaidLeaveDialog
                disabled={!!item.deleted_at}
                style={{ flex: '50%' }}
                button={EditButton}
                item={item}
                title={EDIT}
                renderRows={renderRows}
                userInfo={userInfo}
                generalSettings={generalSettings}
              />
              <MDButton
                disabled={!!item.deleted_at}
                style={{ flex: '50%' }}
                component="a"
                href="#"
                onClick={() => { setConfirm(true); setDeleteID(item.id) }}
                variant="caption"
                color="text"
                fontWeight="medium"
              >
                Delete
              </MDButton>
            </div >
          )
        }
      })
      setData(res.data);
    });
    setRenderLock(false);
  }

  const columns = [
    { Header: "Employee ID", accessor: "employeeNumber", align: "left" },
    { Header: "Region", accessor: "region", align: "left" },
    { Header: "Native Name", accessor: "nativeName", align: "left" },
    { Header: "Name", accessor: "name", align: "left" },
    { Header: "Email", accessor: "email", align: "left" },
    { Header: "Return Device DateTime", accessor: "returnDeviceAt", align: "left" },
    { Header: "Suspend Start Date", accessor: "suspendStartAt", align: "left" },
    { Header: "Suspend End Date", accessor: "suspendEndAt", align: "left" },
    { Header: "Action", accessor: "action", align: "center" },
  ];

  if (!authState?.isAuthenticated) {
    return null;
  }

  return (
    <EmployeeLayout
      isHiddenStatus={true}
      onFilterChange={handleChangeFilter}
      onPageChange={handleChangePage}
      data={data}
      columns={columns}
    >
      <UnpaidLeaveDialog
        button={NewButton}
        title={NEW}
        renderRows={renderRows}
        userInfo={userInfo}
        generalSettings={generalSettings}
      />
      <ConfirmationDialog
        title="Confirm Action"
        description="Are you sure you want to delete the employee?"
        open={openConfirm}
        setOpen={setConfirm}
        onConfirm={handleDelete}
      ></ConfirmationDialog>
    </EmployeeLayout>
  );
};

export default UnpaidLeave;